import Vue from 'vue'

export const contact = data => Vue.axios.post('contact', data)



// WEBPACK FOOTER //
// ./src/services/contact.js